import React, { useEffect, useState } from "react";
import { get_rutas } from "../../../actions/usuario";
import { TreeSelect } from "antd";

const fn_LoadChildren = ({ allRutas = [], patternId }) => {
  let opts = [];
  const childrens = allRutas?.filter(
    (x) => x.rutapadre === patternId && x.eslink === false
  );
  childrens.forEach((row) => {
    let objRuta = {
      title: row?.nombre,
      value: row?.id,
    };
    const childs = allRutas?.filter((x) => x.rutapadre === row?.id);
    if (childs.length > 0) {
      let objRutaChild = fn_LoadChildren({ allRutas, patternId: row?.id });
      objRuta = { ...objRuta, children: objRutaChild };
    }
    opts = [...opts, objRuta];
  });
  return opts;
};

export const RutaPadreSelect = ({ ...props }) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    const OnLoad = async () => {
      const data = await get_rutas();
      const datos = fn_LoadChildren({ allRutas: data, patternId: null });
      setOptions(datos);
    };
    OnLoad();
    return () => {
      setOptions([]);
    };
  }, []);
  return (
    <TreeSelect
      showSearch
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      popupMatchSelectWidth={false}
      // placement={placement}
      allowClear
      treeDefaultExpandAll
      treeData={options}
      placeholder="[------]"
      {...props}
    />
  );
};
